import './App.css';
import {AppBar, Box, Toolbar, Typography} from "@mui/material"
//@ts-ignore
import logo from "./assets/logo.png"
import AuthPage from './pages/AuthPage';
import ApplicantsPage from './pages/ApplicantsPage';

import {Navigate, Route, Routes, useNavigate} from "react-router-dom";
import PartyPage from './pages/PartyPage';
import ResetPassword from './pages/ResetPassword';
import ActivatePage from './pages/ActivatePage';
import AuthenticatorPage from "./pages/AuthenticatorPage";
import TwoFactorAuthentication from "./pages/TwoFactorAuthentication";
import PhoneNumberPage from "./pages/PhoneNumberPage";
import PhoneTwoFactorAuthentication from "./pages/PhoneTwoFactorAuthentication";
import {useTranslation} from 'i18nano';
import NotificationsComponent from "./components/NotificationComponent";
import AppBarMenu from "./components/AppBarMenu";
import AuthCheckComponent from "./components/AuthCheckComponent";
import {useUserStore} from "./stores/userStore";
import AgentPage from "./pages/AgentPage";
import ClientPartiesPage from "./pages/ClientPartiesPage";

export const API_URL = window.location.hostname === "cflow.carolynleepllc.com"
        ? "https://api.cflow.carolynleepllc.com"
        : "https://dev.api.cflow.carolynleepllc.com";

const App = () => {
    const navigate = useNavigate();
    const t = useTranslation();
    const userStore = useUserStore();

    return (
            <>
                <NotificationsComponent/>
                <Box sx={{flexGrow: 1}}>
                    <AppBar position="static">
                        <Toolbar sx={{height: 80}}>
                            <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                                <img alt={logo} src={logo} style={{height: "40px"}} onClick={() => navigate("/")}/>
                            </Typography>
                            <AppBarMenu/>
                        </Toolbar>
                    </AppBar>
                </Box>
                <AuthCheckComponent>
                    <Routes>
                        {
                            userStore.status === "AUTHENTICATED"
                                    ?
                                    <>
                                        <Route path="/parties" element={<ApplicantsPage/>}/>
                                        <Route path="/parties/:id" element={<ApplicantsPage/>}/>
                                        <Route path="/party/:id" element={<PartyPage/>}/>
                                        <Route path="/agent/:id/clients" element={<AgentPage/>}/>
                                        <Route path="/agent/:agentId/clients/:clientId/parties"
                                               element={<ClientPartiesPage/>}/>
                                        <Route path="/agent/:agentId/clients/:clientId/parties/:id"
                                               element={<PartyPage isAgent={true}/>}/>
                                        <Route
                                                path="*"
                                                element={<Navigate to="/parties"/>}
                                        />
                                    </>
                                    :
                                    <>
                                        <Route path="/login" element={<AuthPage/>}/>
                                        <Route path="/reset" element={<ResetPassword/>}/>
                                        <Route path='/activate'
                                               element={<ActivatePage title={t("Activate account")}/>}/>
                                        <Route path='/restore' element={<ActivatePage title={t("Reset password")}/>}/>
                                        <Route path='/authenticator' element={<AuthenticatorPage/>}/>
                                        <Route path='/two-factor-authentication/phone'
                                               element={<PhoneTwoFactorAuthentication/>}/>
                                        <Route path='/two-factor-authentication' element={<TwoFactorAuthentication/>}/>
                                        <Route path='/phoneAuthenticator' element={<PhoneNumberPage/>}/>
                                        <Route
                                                path="*"
                                                element={<Navigate to="/login"/>}
                                        />
                                    </>
                        }
                    </Routes>
                </AuthCheckComponent>

            </>
    );
}

export default App;
